import { render, staticRenderFns } from "./ClickUpAssignementNeeded.vue?vue&type=template&id=26b98950&"
import script from "./ClickUpAssignementNeeded.vue?vue&type=script&lang=js&"
export * from "./ClickUpAssignementNeeded.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports